export class Step7 {
  constructor() {}

  getnoserviceexecutant = 'bloc_commun.divers.getnoserviceexecutant';
  getnumboncommande = 'bloc_commun.divers.getnumboncommande';
  getspan6 = 'bloc_commun.divers.getspan6';
  getspan7 = 'bloc_commun.divers.getspan7';
  getregion = 'bloc_commun.divers.getregion';
  getdepartement = 'bloc_commun.divers.getdepartement';
  getetat = 'bloc_commun.divers.getetat';
  getdebiteuretranger = 'bloc_commun.divers.getdebiteuretranger';
  getdebiteurprivepersmorale = 'bloc_commun.divers.getdebiteurprivepersmorale';
  getdebiteurprivepersphysique = 'bloc_commun.divers.getdebiteurprivepersphysique';
  getgroupementcollectivites = 'bloc_commun.divers.getgroupementcollectivites';
  getcommune = 'bloc_commun.divers.getcommune';
  getetablissementspublicssante = 'bloc_commun.divers.getetablissementspublicssante';
  getautresorganismespublics = 'bloc_commun.divers.getautresorganismespublics';
  getsiret = 'bloc_commun.divers.getsiret';
  getdenomination = 'bloc_commun.divers.getdenomination';
  getadr4 = 'bloc_commun.divers.getadr4';
  getadr3 = 'bloc_commun.divers.getadr3';
  getadr2 = 'bloc_commun.divers.getadr2';
  getadr1 = 'bloc_commun.divers.getadr1';
  getcp = 'bloc_commun.divers.getcp';
  getville = 'bloc_commun.divers.getville';
  getpays = 'bloc_commun.divers.getpays';
  gettvaIntracommunautaire = 'bloc_commun.divers.gettvaIntracommunautaire';


}
